import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Container, Button, Segment, Loader } from 'semantic-ui-react'
import * as actions from '../../../actions'
import DashboardCard from './DashboardCard'
import ResellerTables from './ResellersTable'
import OrdersTable from './OrdersTable'
import PackagesTable from './PackagesTable'
import { filterOrdersByDate, getRevenue, getCost, numberWithCommas } from './utils'
import './Dashboard.css'

const Dashboard = () => {
    const dispatch = useDispatch()
    const orders = useSelector(state => state.orders)
    const resellers = useSelector(state => state.resellers)
    const isLoading = !orders || !resellers

    useEffect(() => {
        dispatch(actions.fetchOrders(true))
        dispatch(actions.fetchResellers())
    }, [dispatch])

    const refreshData = () => {
        dispatch(actions.fetchOrders(true))
        dispatch(actions.fetchResellers())
    }

    if (isLoading) {
        return <Loader active size="large" inverted>Loading</Loader>
    }

    const lifetimeOrders = filterOrdersByDate(orders, 1000000)
    const totalRevenue = getRevenue(lifetimeOrders)
    const totalProfit = totalRevenue - getCost(lifetimeOrders)

    return (
        <Container inverted style={{ background: '#1b1c1d', minHeight: '100vh' }}>
            <h1 style={{ display: 'flex', alignItems: 'center', marginTop: 30, marginBottom: 20, color: 'white' }}>
                Dashboard <Button inverted style={{ marginLeft: 15 }} size="small" icon="refresh" color="teal" onClick={refreshData}/>
            </h1>
            <div className="dashboard-container">
                <DashboardCard value={numberWithCommas(lifetimeOrders.length)} label="Total Orders" />
                <DashboardCard value={`$${numberWithCommas(totalRevenue.toFixed(2))}`} label="Total Revenue" />
                <DashboardCard value={`$${numberWithCommas(totalProfit.toFixed(2))}`} label="Total Profit" />
            </div>
            <Segment inverted style={{ background: '#1b1c1d', padding: 25 }}>
                <h2 style={{ color: 'white' }}>Orders</h2>
                <OrdersTable orders={orders} />
            </Segment>
            <Segment inverted style={{ background: '#1b1c1d', padding: 25 }}>
                <ResellerTables orders={orders} resellers={resellers} />
            </Segment>
            <Segment inverted style={{ background: '#1b1c1d', marginBottom: 60, padding: 25 }}>
                <h2 style={{ color: 'white' }}>Packages</h2>
                <PackagesTable orders={orders} />
            </Segment>
        </Container>
    )
}

export default Dashboard